import { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import { LegalDocumentParams, LegalVersionsResponse } from "./types"

export const getVersions = (
	apiClient: APIClient,
): Promise<LegalVersionsResponse> =>
	apiClient.get("/generated/versions.json").then(response => response.data)

export const getLegalDocument = (
	apiClient: APIClient,
	params: LegalDocumentParams,
): Promise<string> => {
	const { product, documentType, region, language, version } = params

	return apiClient
		.get(
			`/generated/${product}/${documentType}/${region}/${language}/${version}.html`,
		)
		.then(response => response.data)
}
